<template>
	<div>
		<myheader :backFlag="true" :myBackgroundColor="'#98e2af'" headTitle="签约减碳助力值"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back" style="background-color: #98e2af;"></div>
			<div class="header_extend_content_height">
				<div class="all_tips_content_card_padding8 all_text_center" style="height: 86vh;">
					<div class="margin_top_10 all_text_center" style="position: relative;">
						<img src="@/assets/images/ecsotop.png"
							style="position: absolute;top: 0;left:25%; height: 1.6rem;width: 50%;object-fit: fill;" />
						<span class="text14"
							style="padding: .2rem .5rem;color: #1f732d;">{{'累计签订 '+contractCount+' 份合同'}}</span>
					</div>
					<div class="margin_top_10">
						<img src="@/assets/images/ecsocenter.png" style="width: 8rem;height: 8rem;object-fit: fill;" />
					</div>
					<div class="text14 textcolor333 margin_top_10">在石化e签平台，您已累计减少碳排放</div>
					<div class="margin_top_10" @click="toDetails()">
						<span class="text36 textcolor98e2af font_weight_bold">{{contractScore}}</span>
						<span class="text18 textcolor98e2af">&nbsp;&nbsp;克&nbsp;></span>
					</div>
					<div style="margin-top: 2rem;">
						<span class="text16 textcolor999 all_text_center display_block"
							style="position: relative; width: 60%;left: 20%;font-style: oblique">签约减碳，绿色共创</span>
					</div>
				</div>
			</div>
		</div>
		<!-- <div style="position: fixed; bottom: 1rem; left: 0;right: 0;">
			<span class="text12 textcolor98e2af all_text_center display_block"
				style="position: relative; width: 60%;left: 20%;">签约减碳计算模型由石化e签联合北京绿色交易所提供</span>
		</div> -->
	</div>
</template>

<script>
	import Vue from 'vue'
	export default {
		name: 'energyconservationselfoverview',
		data() {
			return {
				//
				contractCount: '',
				//
				contractScore: ''
			}
		},
		methods: {
			//去明细页面
			toDetails() {
				//if(contractScore){
					this.$router.push({
						path: '/energyconservationselflist',
						query:{
							contractScore:this.contractScore
						}
					});
				//}
			},
			//根据登陆人查询签订的合同份数和碳积分
			queryContractScore() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/score/m/api/queryContractScore')
					.then(res => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							this.contractCount = res.data.contractCount
							this.contractScore = res.data.contractScore
						}
					}).catch(err => {
						this.$store.dispatch(this.$LoadShow, false)
					})
			},
			//初始化
			init() {
				this.queryContractScore()
			},
		},
		mounted() {
			this.init()
		}
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";

	.ecsotop {
		background-image: url('../../../assets/images/ecsotop.png');
		background-size: fill;
	}
</style>